import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Button } from "@parkschannel/ui";
import { useAuth } from "../../Auth/AuthContext";
import { useUser } from "../hooks";
import classNames from "classnames";
export const SubscribeButton = (param)=>{
    let { accountId , className , isSubscribed , onSuccess , button  } = param;
    const { useSession  } = useAuth();
    const { data  } = useSession();
    const { useSubscribeAccountMutationQuery  } = useUser();
    const { mutateAsync , isLoading  } = useSubscribeAccountMutationQuery({
        onSuccess
    });
    if (!data || data.user.cognito_id === accountId) return null;
    if (button) return /*#__PURE__*/ _jsx(_Fragment, {
        children: button({
            subscribe: mutateAsync,
            isLoading,
            isSubscribed
        })
    });
    return /*#__PURE__*/ _jsx(Button, {
        disabled: isLoading,
        variant: "base",
        onClick: ()=>mutateAsync(accountId),
        className: classNames({
            "bg-neutral-100": isSubscribed
        }, "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]", className),
        children: isSubscribed ? "Subscribed" : "Subscribe"
    });
};
